import { OrderWithDetails } from '../types/order';
import { INVOICE_STATUS } from './invoice-status';
import { ORDER_STATUS } from './order-status';

export type BulkInvoiceIneligibleReason =
    | 'not_completed'
    | 'already_certified'
    | 'already_processing'
    | 'already_cancelled';

export interface BulkInvoiceEligibility {
    eligible: boolean;
    reason?: BulkInvoiceIneligibleReason;
    message?: string;
}

export default function isOrderBulkInvoiceable(order: OrderWithDetails): BulkInvoiceEligibility {
    if (order.status !== ORDER_STATUS.COMPLETED) {
        return {
            eligible: false,
            reason: 'not_completed',
            message: 'Solo se pueden facturar pedidos completados.',
        };
    }

    if (order.invoice) {
        if (order.invoice.status === INVOICE_STATUS.CERTIFIED) {
            return {
                eligible: false,
                reason: 'already_certified',
                message: order.invoice.authorizationNumber
                    ? `Este pedido ya tiene factura certificada — UUID ${order.invoice.authorizationNumber}.`
                    : 'Este pedido ya tiene factura certificada.',
            };
        }

        if (order.invoice.status === INVOICE_STATUS.PENDING) {
            return {
                eligible: false,
                reason: 'already_processing',
                message: 'Este pedido ya está siendo procesado.',
            };
        }

        if (order.invoice.status === INVOICE_STATUS.CANCELLED) {
            return {
                eligible: false,
                reason: 'already_cancelled',
                message: 'Este pedido tiene una factura anulada — no se puede reencolar.',
            };
        }
    }

    return { eligible: true };
}

export function getIneligibleShortLabel(reason: BulkInvoiceIneligibleReason): string {
    switch (reason) {
        case 'not_completed':
            return 'no completado';
        case 'already_certified':
            return 'ya facturada';
        case 'already_processing':
            return 'en proceso';
        case 'already_cancelled':
            return 'anulada';
    }
}
